import React, { useState } from "react";
import clsx from "clsx";
import ReactGA from "react-ga4";
import { useHistory } from "react-router";
import { DateTimeStandard, Typography, Box, Divider, Stack } from "@curves/ui-base";
import useNotificationApi from "@apis/useNotificationApi";
import { parseDate } from "@util/moment";
import { serialize, isEqual } from "@util/utils";
import { ACCOUNT_BOOK_ORDERS_OVERVIEW_URL, ACCOUNT_BOOK_TRIPLICATE_INVOICE_ALLOWANCE_OVERVIEW } from "@icoach/router/routerPath";
import { CLUB_DOCUMENTS_ROUTER } from "@icoach/router/routerPath";
import { initBookmark } from "@icoach/notifications/staticData";
import { initBookmark as membersInitBookmark } from "@icoach/members/staticData";
import { MEMBERS_MEMBER_DETAIL_TABS } from "@icoach/constants/";
import { CLUB_MEMBERS_ROUTER } from "@icoach/router/routerPath";
import { TRANSFERIN_ENTEREDTYPE, TRANSFEROUT_MOVETYPE, NOTIFICATION_SOURCE_TYPE } from "@icoach/constants/";

const NotificationTable = React.forwardRef((props, ref) => {
    const { sourceData: sourceDataProps, isLast = false, notificationType } = props;
    const { putNotificationReadApi } = useNotificationApi();
    const history = useHistory();
    const {
        title = "",
        textContent: content = "",
        recordTime: datetime = null,
        isRead: isReadProps,
        targetPayload,
        notificationID,
        targetType
    } = sourceDataProps;
    const [isRead, setRead] = useState(isReadProps);

    const handleRowClick = () => {
        if (isEqual(notificationType, NOTIFICATION_SOURCE_TYPE.TRANSFERIN)) {
            const { ReferenceID, ReferenceType } = JSON.parse(targetPayload);
            // 只會有尚未移入的紀錄ROUTER，不會有已移入的歷史，該會員已移入就表示有填寫入會申請書不需有已移入的歷史
            const path = CLUB_DOCUMENTS_ROUTER.TRANSFERIN.GET_REFERENCEID_PATH(TRANSFERIN_ENTEREDTYPE.UNENTERED, ReferenceType, ReferenceID);
            doPageChangeApi(null, path);
        } else if (isEqual(notificationType, NOTIFICATION_SOURCE_TYPE.TRANSFEROUT)) {
            const { ReferenceID, ReferenceType } = JSON.parse(targetPayload);
            const path = CLUB_DOCUMENTS_ROUTER.TRANSFEROUT.GET_HISTORY_PATH(TRANSFEROUT_MOVETYPE.MOVEOUT, ReferenceType, ReferenceID);
            doPageChangeApi(null, path);
        } else if (isEqual(notificationType, NOTIFICATION_SOURCE_TYPE.MEMBERSHIPEXPIRED)) {
            let quickType;
            const { StartDate, EndDate, RangeType, MembershipStatus } = JSON.parse(targetPayload);
            let params = {};
            switch (String(targetType)) {
                case "302":
                    quickType = 4;
                    params = {
                        ...membersInitBookmark(),
                        membershipStatus: MembershipStatus,
                        startDate: parseDate(StartDate, DateTimeStandard.DisplayDate),
                        endDate: parseDate(EndDate, DateTimeStandard.DisplayDate),
                    };
                    break;
                default:
                    quickType = 2;
                    params = {
                        rangeType: RangeType,
                        ...membersInitBookmark(),
                    };
            }
            const path = CLUB_MEMBERS_ROUTER.MEMBER_OVERVIEW.GET_QUICK_PATH(quickType);
            doPageChangeApi(serialize(params), path);
        } else if (isEqual(notificationType, NOTIFICATION_SOURCE_TYPE.VERSION)) {
            doOpenPDFApi();
        } else if (isEqual(notificationType, NOTIFICATION_SOURCE_TYPE.INVOICE)) {
            const {
                Name, StartDate, EndDate,
                ReturnInvoiceStatus,
                OrderSourceType, OrderStatus, ReceiverType, OrderType
            } = JSON.parse(targetPayload);
            let params = {};
            let path = "";
            switch (String(targetType)) {
                case "403":
                    params = serialize({
                        returnInvoiceStatus: ReturnInvoiceStatus || "0",
                        name: Name || "",
                        startDate: StartDate || "",
                        endDate: EndDate || "",
                        ...initBookmark(),
                    });
                    path = ACCOUNT_BOOK_TRIPLICATE_INVOICE_ALLOWANCE_OVERVIEW;

                    break;
                default:
                    params = serialize({
                        activeTab: OrderSourceType || "",
                        orderSourceType: OrderSourceType || "",
                        status: OrderStatus || ",",
                        name: Name || "",
                        startDate: StartDate || "",
                        endDate: EndDate || "",
                        receiverType: ReceiverType || "",
                        orderType: OrderType || "",
                        ...initBookmark(),
                    });
                    path = ACCOUNT_BOOK_ORDERS_OVERVIEW_URL;
                    break;
            }

            doPageChangeApi(params, path);
        } else if (isEqual(notificationType, NOTIFICATION_SOURCE_TYPE.CYCLEPURCHASE)) {
            const { MemberID } = JSON.parse(targetPayload);
            const path = CLUB_MEMBERS_ROUTER.MEMBER_DETAIL.GET_TABS_PATH(MemberID, MEMBERS_MEMBER_DETAIL_TABS.HC);
            doPageChangeApi(null, path);
        }
    };

    const doPageChangeApi = async (params, path) => {
        let resp;
        let _r = path;
        if (params) _r = _r + "?" + params;
        if (!isRead) {
            resp = await putNotificationReadApi(notificationID);
            if (!resp) {
                return;
            }
        }
        history.push(_r);
    };

    const doOpenPDFApi = async () => {
        ReactGA.event({ category: "新版本通知", action: `新版本通知 ${parseDate(datetime)}`, label: "通知" });
        await window.open(targetPayload, `blank`);
        if (!isRead) {
            await putNotificationReadApi(notificationID);
            setRead(true);
        }
    };

    return (
        <React.Fragment>
            <Box className={clsx(isRead && "bg-white", "p-2", "cursor-pointer")} onClick={handleRowClick}>
                <Stack>
                    <Box className={clsx("notification-dot", isRead && "read")} />
                    <Box className="flex-grow-1">
                        <Typography className="font-weight-bold">{title}</Typography>
                        <Box className="py-1">{content}</Box>
                        <Typography>{parseDate(datetime)}</Typography>
                    </Box>
                </Stack>
            </Box>
            {!isLast && <Divider />}
        </React.Fragment>
    );
});

export default NotificationTable;
